import getInstanceAxios from "../request"
const baseDomain = process.env.NEXT_PUBLIC_NOTICATION
const baseURL = `${baseDomain}/`

export default getInstanceAxios(baseURL)
